import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { menuItemsForCustomComp } from '../../common/utils/api_utils';

const CustomComponentMenu = () => {
  const location = useLocation();
  const { projectId, version } = useParams();
  const basePath = `/2.0/custom-component/${version}/v/${projectId}`;
  const getBasePath = (key) => `${basePath}/${key}`;
  const isActive = (key) => location.pathname.startsWith(getBasePath(key));
  const dropdownColor = menuItemsForCustomComp.some((item) => isActive(item.key))
    ? 'theme-green--dropdown'
    : 'theme-primary--dropdown';

  return (
    <UncontrolledDropdown group className="ml-2">
      <DropdownToggle color={dropdownColor} title="Custom Component" className="btn-md" caret>
        <i className={`wb ${drapcodeIcon('customComponent')}`}></i> Custom Component
      </DropdownToggle>
      <DropdownMenu>
        {menuItemsForCustomComp.map((item) => (
          <DropdownItem
            key={item.key}
            tag={Link}
            to={getBasePath(item.key)}
            className={`theme-primary ${isActive(item.key) ? 'active' : ''}`}
          >
            <i className={`wb ${drapcodeIcon(item.icon)}`}></i>&nbsp;{item.label}&nbsp;
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default CustomComponentMenu;
